import React, { Component } from 'react';
//import 'react-day-picker/lib/style.css';
import './header.scss';
import Modal from 'react-awesome-modal';
import axios from 'axios';

class HeaderComponent extends Component {

    state = {
        modalVisible : false,
        weekTotal : 0,
        bestDay : {},
        bestThreeWeeks : null,
        weeksAverageProdUrl : 'https://hanna-sprint-api.herokuapp.com/hannasprint/getWeeksAverage/',
        bestDayProdUrl : `https://hanna-sprint-api.herokuapp.com/hannasprint/getBestDay/`,
        bestThreeWeeksProdUrl : `https://hanna-sprint-api.herokuapp.com/hannasprint/getTopThreeWeeks/`,
        weeksAverageDevUrl : 'http://localhost:3000/hannasprint/getWeeksAverage/',
        bestDayDevUrl : `http://localhost:3000/hannasprint/getBestDay/`,
        bestThreeWeeksDevUrl : `http://localhost:3000/hannasprint/getTopThreeWeeks/`,
    }

    componentDidMount() {
        let weeksAverage = axios.get(`${process.env.NODE_ENV !== 'production' ? this.state.weeksAverageDevUrl : this.state.weeksAverageProdUrl }`);
        let bestDay = axios.get(`${process.env.NODE_ENV !== 'production' ? this.state.bestDayDevUrl : this.state.bestDayProdUrl}`);
        let bestThreeWeeks = axios.get(`${process.env.NODE_ENV !== 'production' ? this.state.bestThreeWeeksDevUrl : this.state.bestThreeWeeksProdUrl }`);
        axios.all([weeksAverage, bestDay, bestThreeWeeks]).then(axios.spread((...responses) => {
           this.setState({
               weekTotal : responses[0].data.WeekAverage,
               bestDay : responses[1].data.bestDay,
               bestThreeWeeks : responses[2].data.test
            })
        }))
        .catch(err => console.log(err));
    }

    openModal() {
        
        this.setState({
            modalVisible : true
        });
    }

    closeModal() {
        this.setState({
            modalVisible : false
        });
    }

    getGoodWeek = (week, year) => {
        this.props.handleGetBestWeek(year, week);
        setTimeout(() => {
            this.closeModal();
        }, 400);
        const titleElement = document.getElementById('week-wrapper')
        titleElement.scrollIntoView({ behavior: 'smooth' })
    }

    getBestDay = (date) => {
        this.props.handleGetBestDay(date);
        setTimeout(() => {
            this.closeModal();
        }, 400);
        const titleElement = document.getElementById('week-wrapper')
        titleElement.scrollIntoView({ behavior: 'smooth' })
    }

    
    render(){

        const columns = [
            { field: 'id', headerName: 'Id', width: 50 },
            { field: 'stat', headerName: 'Stat', width: 200 },
            {
              field: 'value',
              headerName: 'Value',
              width: 400,
            }
            
        ];
        let rows = []
        if (this.state.bestThreeWeeks !== null)
        {
            rows = [
                
                {id : 1, stat: "Breed", value: "Hybrid Dwarf Hamster"},
                {id : 2, stat: "Week average", value: `${(this.state.weekTotal / 100000).toFixed(2)} km`  },
                {id : 3, stat: "Best day", value: this.state.bestDay.date },
                {id : 4, stat: "Best day distance", value: (this.state.bestDay.totalDistance / 100000).toFixed(2)},
                {id : 5, stat: "Best week", value:  `Week ${this.state.bestThreeWeeks[0]._id} in ${this.state.bestThreeWeeks[0].year} : ${(this.state.bestThreeWeeks[0].total / 100000).toFixed(2)} km`},
                {id : 6, stat: "Second best week", value:  `Week ${this.state.bestThreeWeeks[1]._id} in ${this.state.bestThreeWeeks[1].year} : ${(this.state.bestThreeWeeks[1].total / 100000).toFixed(2)} km`},
                {id : 7, stat: "Third best week", value: `Week ${this.state.bestThreeWeeks[2]._id} in ${this.state.bestThreeWeeks[2].year} : ${(this.state.bestThreeWeeks[2].total / 100000).toFixed(2)} km`}
            ];
        }
        return(
        <div>
            <header>
                <div className="overlay">
                    <h1>Hanna Sprint</h1>
                    <h3>Distance statistics for the one and only Hanna the Hamster </h3>
                    <p>Please select a week on the calendar below</p>

                    <button onClick={() => this.openModal()}>READ MORE</button>
                    <Modal visible={this.state.modalVisible} width="80%" height="85%" effect="fadeInUp" onClickAway={() => this.closeModal()}>
                    <h1 className="modal--headline">Hanna</h1>
                    <div className="stats-div">
                        
                        <table className="header--table" style={{width:'100%'}}>
                            <thead>
                                <tr>
                                    
                                    <th>Stat</th>
                                    <th>Value</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                           {rows.map((row, key) => {
                               
                                return(
                                <tr key={key}>
                                    <td>{row.stat}</td>
                                    {row.id === 3 && <td><button className="table--row--button" onClick={() => this.getBestDay(row.value)}>{row.value}</button></td>} 
                                    {row.id === 5 && <td><button className="table--row--button" onClick={() => this.getGoodWeek(this.state.bestThreeWeeks[0]._id, this.state.bestThreeWeeks[0].year)}>{row.value}</button></td>}
                                    {row.id === 6 && <td><button className="table--row--button" onClick={() => this.getGoodWeek(this.state.bestThreeWeeks[1]._id, this.state.bestThreeWeeks[1].year)}>{row.value}</button></td>}
                                    {row.id === 7 && <td><button className="table--row--button" onClick={() => this.getGoodWeek(this.state.bestThreeWeeks[2]._id, this.state.bestThreeWeeks[2].year)}>{row.value}</button></td>}
                                    <td>{
                                    row.id !== 3
                                    && row.id !== 5
                                    && row.id !== 6
                                    && row.id !== 7 && row.value}</td>
                               </tr>
                               )
                           })}
                            </tbody>
                            
                            
                        </table>
                        {/* <div style={{ height: '300px', width: '100%', marginBottom: '50px' }}>
                            <DataGrid rows={rows} columns={columns} pageSize={rows.length} disableColumnMenu="true" hideFooter="true"/>
                        </div>
                         */}
                        
                    </div>
                    <button className="modal--button--close" style={{backgroundColor: 'lightcoral'}} onClick={() => this.closeModal()}>Close</button>
                    </Modal>
                   
                    
                </div>
            </header>
        
            <link rel="preconnect" href="https://fonts.gstatic.com" />
            <link href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap" rel="stylesheet" />
        </div>
        )
    }
}

export default HeaderComponent;
